// One codebase, several domains. Each profile changes the wordmark, hero
// copy, which section leads the page, and which activity block is featured.
// Everything else is shared. Add a photo later by setting `heroPrefix` to a
// new image set in public/images (e.g. 'tride-bike'). A set needs 768, 1280,
// 1920, and 3840 widths in both .avif and .webp, and the hero preload script in
// public/index.html has to learn the new prefix.

const profiles = {
  events: {
    key: 'events',
    hosts: ['tellurideevents.com'],
    name: 'Telluride Events',
    title: 'Telluride Colorado',
    tagline: "Experience the magic of Colorado's most beautiful mountain town",
    description: 'Your guide to events, skiing, dining, and more in Telluride, Colorado.',
    cta: { label: 'Explore Events', href: '#events-section' },
    heroPrefix: null, // null = follow the season
    lead: 'events',
    featured: null, // null = seasonal default
    accent: 'blue',
  },
  bike: {
    key: 'bike',
    hosts: ['biketelluride.com'],
    name: 'Bike Telluride',
    title: 'Bike Telluride',
    tagline: 'Lift-served downhill, alpine singletrack, and easy valley cruising',
    description:
      'Mountain biking, the Telluride Bike Park, trails, and everything else you need for a ride in Telluride, Colorado.',
    cta: { label: 'Find a Ride', href: '#things-to-do-section' },
    heroPrefix: 'tride-summer',
    lead: 'things',
    featured: 'biking',
    accent: 'emerald',
  },
  fourbyfour: {
    key: 'fourbyfour',
    hosts: ['4x4telluride.com'],
    name: '4x4 Telluride',
    title: '4x4 Telluride',
    tagline: 'Black Bear, Imogene, Ophir: the classic San Juan passes and how to run them',
    description:
      'Off-road trails, pass conditions, and 4x4 routes around Telluride, Colorado.',
    cta: { label: 'Check Pass Conditions', href: '#things-to-do-section' },
    heroPrefix: 'tride-summer',
    lead: 'things',
    featured: 'offroading',
    accent: 'orange',
  },
  music: {
    key: 'music',
    hosts: ['telluridemusicfestival.com'],
    name: 'Telluride Music Festivals',
    title: 'Telluride Music Festivals',
    tagline: 'Bluegrass, jazz, blues, and film in a box canyon',
    description:
      'Bluegrass, Jazz, Blues & Brews, the Film Festival, and every other festival in Telluride, Colorado.',
    cta: { label: 'See the Festivals', href: '#events-section' },
    heroPrefix: 'tride-summer',
    lead: 'events',
    featured: 'festivals',
    accent: 'violet',
  },
};

const matchHost = (hostname) => {
  const host = hostname.replace(/^www\./, '').toLowerCase();
  return Object.values(profiles).find((p) => p.hosts.includes(host));
};

// Resolves the active profile. `?site=bike` overrides for local previews.
export const getSite = (loc = typeof window !== 'undefined' ? window.location : null) => {
  if (!loc) return profiles.events;
  const param = new URLSearchParams(loc.search).get('site');
  if (param && profiles[param]) return profiles[param];
  return matchHost(loc.hostname) || profiles.events;
};

export const site = getSite();
export const allSites = profiles;
